import { Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef
} from 'primeng/dynamicdialog';

import { Subscription } from 'rxjs';
import { IContact } from 'src/app/common/model/contacts.model';
import { CreateContactComponent } from 'src/app/common/modules/contacts/components/create-contact/create-contact.component';
import { ContactsService } from 'src/app/common/services/contacts/contacts.service';
import { UtilService } from 'src/app/common/services/util/util.service';

@Component({
  selector: 'app-customers-search',
  templateUrl: './customers-search.component.html',
  styleUrls: ['./customers-search.component.scss']
})
export class CustomersSearchComponent implements OnInit {
  @Input() customerId = '';
  @Output() passEntry = new EventEmitter<{ customer: any }>();
  customers = signal<IContact[]>([]);
  subscription = new Subscription();
  rows = 50;
  defaultPagination = {
    page: 0,
    pageSize: this.rows,
    searchParam: null
  };
  searchText: any;
  tableColumns: {
    displayName: string;
    fieldName: string;
  }[] = [
    {
      displayName: 'name',
      fieldName: 'name'
    },
    {
      displayName: 'location',
      fieldName: 'city'
    },
    {
      displayName: 'telephone',
      fieldName: 'phoneNumber'
    }
  ];
  selectedContact!: IContact;
  showCreateCustomer = false;

  addCustomerForm = new FormGroup({});
  model: any = {};
  options: FormlyFormOptions = {
    formState: {
      isSubCustomer: true
    }
  };
  createCustomerFormlyFields: FormlyFieldConfig[] = [];

  constructor(
    public utilService: UtilService,
    private contactService: ContactsService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService
  ) {}

  ngOnInit(): void {}

  getPaginatedCustomers(): void {
    this.subscription.add(
      this.contactService.getPaginatedCustomers(this.defaultPagination).subscribe({
        next: (res) => {
          this.customers.set(res.result.data);
        }
      })
    );
  }

  getSearchResults(): void {
    if (this.searchText) {
      this.defaultPagination = {
        ...this.defaultPagination,
        searchParam: this.searchText
      };
      this.getPaginatedCustomers();
    } else {
      this.defaultPagination = {
        ...this.defaultPagination,
        searchParam: null
      };
      this.getPaginatedCustomers();
    }
  }

  emitSelectedCustomer() {
    this.ref.close(this.selectedContact);
  }
  emitCreateNewCustomer() {
    this.ref.close(true);
  }

  openAddCustomerComponent() {
    const ref = this.dialogService.open(CreateContactComponent, {
      header: 'Add a new customer',
      height: '70%',
      width: '80%',
      breakpoints: {
        '960px': '90%',
        '640px': '95%'
      },
      data: { contactType: 'customer' }
    });
    ref.onClose.subscribe((addedCustomer) => {
      if (addedCustomer) {
        this.selectedContact = addedCustomer;
        this.emitSelectedCustomer();
        ref.close();
      }
    });
  }
}
